import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(Meta)

const routes = [
    {
        path: '/auth', component: () => import('../layouts/GuestLayout.vue'),
        children: [
            {path: 'register',name: 'Register',component: () => import( '../views/Auth/Register.vue'), meta: { title: 'Signup your School' }},
            {path: 'login',name: 'Login',component: () => import( '../views/Auth/Login.vue'), meta: { title: 'Login to your School' }},
            {path: 'verify-email',name: 'VerifyEmail',component: () => import( '../views/Auth/VerifyEmail.vue'), meta: { title: 'Verify Email' }},
            {path: 'recover-password',name: 'RecoverPassword',component: () => import( '../views/Auth/RecoverPassword.vue'), meta: { title: 'Recover Password' }},
            {path: 'support-login',name: 'SupportLogin',component: () => import( '../views/Auth/SupportLogin.vue'), meta: { title: 'Support Login' }},
    ]},

    {
        path: '/auth', component: () => import('../layouts/AuthLayout.vue'),
        children: [
            {path: 'dashboard',name: 'ModuleSelector',component: () => import( '../views/Auth/Dashboard.vue'), meta: { title: 'Module Selector Dashboard' }},
            {path: 'token-history',name: 'TokenHistory',component: () => import( '../views/TokenHistory.vue'), meta: { title: 'Token History' }},
    ]},

    {
        path: '/setup', component: () => import('../layouts/SetupLayout.vue'),
        children: [
            {path: 'dashboard',name: 'SetupDashboard',component: () => import( '../views/App/Dashboard.vue'), meta: { title: 'Setup Dashboard' }},
            {path: 'terms',name: 'Terms',component: () => import( '../views/App/Terms.vue'), meta: { title: 'Manage Terms' }},
            {path: 'classes',name: 'Classes',component: () => import( '../views/App/Classes.vue'), meta: { title: 'Manage Classes' }},
            {path: 'subjects',name: 'Subjects',component: () => import( '../views/App/Subjects.vue'), meta: { title: 'Manage Subjects' }},
            {path: 'gradings',name: 'Grades',component: () => import( '../views/App/Grades.vue'), meta: { title: 'Manage Gradings' }},
            {path: 'students',name: 'Students',component: () => import( '../views/App/Students.vue'), meta: { title: 'Manage Students' }},
            {path: 'topup-token',name: 'TopUpToken',component: () => import( '../views/App/VerifyTokenTopup.vue')}
    ]},

    {
        path: '/maccess', component: () => import('../layouts/MultiAccessLayout.vue'),
        children: [
            {path: 'tokens',name: 'GenerateAccessTokens',component: () => import( '../views/App/GenerateTokens.vue'), meta: { title: 'Manage School Users Access' }},
    ]},

    {
        path: '/results', component: () => import('../layouts/ResultLayout.vue'),
        children: [
            {path: 'dashboard',name: 'ResultsDashboard',component: () => import( '../views/App/Dashboard.vue'), meta: { title: 'Results Dashboard' }},
            {path: 'scores',name: 'StudentScores',component: () => import( '../views/App/Scores.vue'), meta: { title: 'Record Scores' }},
            {path: 'sheets',name: 'ResultSheets',component: () => import( '../views/App/ResultSheets.vue'), meta: { title: 'Result Sheets' }},
    ]},

    {
        path: '/attendance', component: () => import('../layouts/AttendanceLayout.vue'),
        children: [
            {path: 'dashboard',name: 'AttendanceDashboard',component: () => import( '../views/Attendance/Dashboard.vue'), meta: { title: 'Attendance Dashboard' }},
            {path: 'student-attendance',name: 'MarkAttendance',component: () => import( '../views/Attendance/MarkAttendance.vue'), meta: { title: 'Record Students Attendance' }},
            {path: 'student-attendance-summary',name: 'AttendanceSummary',component: () => import( '../views/Attendance/AttendanceSummary.vue'), meta: { title: 'Students Attendance Summary' }},
            {path: 'geofence',name: 'GeoFence',component: () => import( '../views/Attendance/GeoFence.vue'), meta: { title: 'Attendance GeoFencing' }},
            {path: 'staff',name: 'ManageStaff',component: () => import( '../views/Attendance/Staff.vue'), meta: { title: 'Manage Teaching Staff' }},
            {path: 'teacher-clock',name: 'TeacherClock',component: () => import( '../views/Attendance/TeacherClock.vue'), meta: { title: 'Teachers Attendance' }},
            {path: 'teacher-clock-summary',name: 'TeacherClockSummary',component: () => import( '../views/Attendance/TeacherClockSummary.vue'), meta: { title: 'Teachers Attendance Summary' }},
    ]},

    {
        path: '/website', component: () => import('../layouts/SchoolWebsiteLayout.vue'),
        children: [
            {path: 'dashboard',name: 'SchoolWebsiteDashboard',component: () => import( '../views/SchoolWebsite/Dashboard.vue'), meta: { title: 'School Website Dashboard' }},
            // {path: 'settings',name: 'SchoolWebsiteSettings',component: () => import( '../views/SchoolWebsite/Settings.vue'), meta: { title: 'Manage School Website Settings' }},
            // {path: 'page-editor',name: 'SchoolWebsitePageEditor',component: () => import( '../views/SchoolWebsite/PageEditor.vue'), meta: { title: 'School Website Page Editor' }},
            // {path: 'media-manager',name: 'SchoolWebsiteMediaManager',component: () => import( '../views/SchoolWebsite/MediaManager.vue'), meta: { title: 'School Website Media Manager' }},
            // {path: 'theme-selector',name: 'SchoolWebsiteThemeSelector',component: () => import( '../views/SchoolWebsite/ThemeSelector.vue'), meta: { title: 'School Website Theme Selector' }},
    ]},
    
    {
        path: '/notes', component: () => import('../layouts/LessonNoteLayout.vue'),
        children: [
            {path: 'dashboard',name: 'LessonNotesDashboard',component: () => import( '../views/LessonNotes/Dashboard.vue')}
    ]},
    
    {
        path: '/access', component: () => import('../layouts/GuestLayout.vue'),
        children: [
            {path: '',name: 'MultiAccessLogin',component: () => import( '../views/MultiAccess/Login.vue'), meta: { title: 'Multi-User Login' }},
        ]
    },

    {
        path: '/', component: () => import('../layouts/LandingLayout.vue'),
        children: [
            {path: '', name: 'Landing', component: () => import('../views/LandingPage/Home.vue')},
            {path: '*',name: 'NotFound',component: () => import( '../views/App/NotFound.vue')},
        ]
    },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

export default router
